<template>
    <div class="ma-4">
        <ClientNav class="hideOnPrint"/>
        <v-row dense class="hideOnPrint">
            <v-col cols="12">

                <v-card>
                    <v-card-title style="background-color: #2b3990">
                        <span class="headline white--text">{{ titleForm }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="6">
                                    <DatePicker
                                        :default-date="newReportDate"
                                        v-model="newReportDate"
                                        label="Report Date"
                                    ></DatePicker>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <DatePicker
                                        :default-date="newPlanDate"
                                        v-model="newPlanDate"
                                        label="Plan Date"
                                    ></DatePicker>
                                </v-col>
                                <v-col cols="12" sm="12">
                                    <v-textarea
                                        v-model="newSummary"
                                        label="Summary"
                                        outlined
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-checkbox
                                        v-model="signedManager"
                                        label="Manager Signature"
                                        outlined
                                        @click="addManagerSig()"
                                    ></v-checkbox>
                                    <v-text-field label="Signed By" v-model="newManagerSignature"
                                                  readonly></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-checkbox
                                        v-model='signedSupervisor'
                                        label="Supervisor Signature"
                                        outlined
                                        @click="addSupervisorSig()"
                                    ></v-checkbox>
                                    <v-text-field label="Signed By" v-model="newSupervisorSignature"
                                                  readonly></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-checkbox
                                        v-model='signedClient'
                                        label="Client Services Signature"
                                        outlined
                                        @click="addClientSig()"
                                    ></v-checkbox>
                                    <v-text-field label="Signed By" v-model="newClientServSig" readonly></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6"></v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <DatePicker
                                        :default-date="newSubmitted"
                                        v-model="newSubmitted"
                                        label="Date Submitted"
                                    ></DatePicker>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <v-select
                                        multiple
                                        label="Providers"
                                        v-model="newProviders"
                                        :items="providers"
                                        item-text="Name"
                                        item-value="Name"
                                    >
                                    </v-select>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <v-select
                                        multiple
                                        label="Email Contact"
                                        v-model="newGuardian"
                                    >
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="white--text" color="#259647" @click="addWeeklySummary()" v-if="createSummary && !isAuditorRole">
                            Save
                        </v-btn>
                        <v-btn
                            fab
                            small
                            @click="printItem()"
                            class="mr-8 mb-2 white--text"
                            color="#2b6993"
                            elevation="4"
                            v-if="updateSummary"
                        >
                            <v-icon>print</v-icon>
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="updateWeeklySummary()" v-if="updateSummary && !isAuditorRole">Update
                        </v-btn
                        >
                        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    </v-card-actions>
                </v-card>

            </v-col>
        </v-row>
        <Foot class="hideOnPrint"/>

        <div id="printItem">
            <h2 class="text-center ma-3">Weekly Summary</h2>
            <v-row>
                <v-col cols="12" sm="12" md="6">
                    <v-menu
                        ref="menu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="newReportDate"
                                label="Report Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="newReportDate"
                            no-title
                            scrollable
                        >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="menu = false"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.menu.save(date)"
                            >
                                OK
                            </v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                    <v-menu
                        ref="menu2"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="newPlanDate"
                                label="Plan Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="newPlanDate"
                            no-title
                            scrollable
                        >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="menu2 = false"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.menu2.save(date)"
                            >
                                OK
                            </v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="12">
                    <span>Summary</span><br>
                    {{ newSummary }}

                </v-col>
                <v-col cols="12" sm="12" md="6">
                    <v-checkbox
                        v-model="signedManager"
                        label="Manager Signature"
                        outlined
                        @click="addManagerSig()"
                    ></v-checkbox>
                    <v-text-field label="Signed By" v-model="newManagerSignature" readonly></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                    <v-checkbox
                        v-model='signedSupervisor'
                        label="Supervisor Signature"
                        outlined
                        @click="addSupervisorSig()"
                    ></v-checkbox>
                    <v-text-field label="Signed By" v-model="newSupervisorSignature" readonly></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                    <v-checkbox
                        v-model='signedClient'
                        label="Client Services Signature"
                        outlined
                        @click="addClientSig()"
                    ></v-checkbox>
                    <v-text-field label="Signed By" v-model="newClientServSig" readonly></v-text-field>
                </v-col>
                <v-col cols="12" sm="6"></v-col>
                <v-col cols="12" sm="12" md="4">
                    <v-menu
                        ref="menu3"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="newSubmitted"
                                label="Date Submitted"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="newSubmitted"
                            no-title
                            scrollable
                        >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="menu3 = false"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.menu3.save(date)"
                            >
                                OK
                            </v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <v-select
                        multiple
                        label="Providers"
                        v-model="newProviders"
                        :items="providers"
                        item-text="Name"
                        item-value="Name"
                    >
                    </v-select>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <v-select
                        multiple
                        label="Email Contact"
                        v-model="newGuardian"
                    >
                    </v-select>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import ClientNav from '@/components/ClientNav'
import Foot from '@/components/Footer'
import DatePicker from "@/components/DateTimePickers/DatePicker.vue";
import {displayError, displaySuccess} from "@/service/notification-message.service";

const url = require("@/client_config/config").url;

export default {
    components: {
        DatePicker,
        ClientNav,
        Foot,
    },
    data: function () {
        return {
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu: false,
            menu2: false,
            menu3: false,
            newSummaryBool: false,
            signedManager: false,
            signedSupervisor: false,
            signedClient: false,
            msg: false,
            search: "",
            text: "",
            weeklySummaries: [],
            weeklySummary: {},
            units: [],
            codes: [],
            tempData: [],
            users: [],
            staff: "",
            unitID: localStorage.getItem('unitID'),
            clientID: this.$route.params.clientID,
            summaryId: this.$route.params.id,
            userID: localStorage.getItem('userID'),
            titleForm: "New Weekly Summary",
            summaryID: "",
            newStartDate: "",
            // newEndDate: "",
            newReportDate: "",
            newPlanDate: "",
            newSummary: "",
            newManagerSignature: "",
            newSupervisorSignature: "",
            newClientServSig: "",
            newSubmitted: "",
            newProviders: "",
            newGuardian: "",
            providers: [],
            isLoading: true,
            createSummary: false,
            updateSummary: false,
        };
    },

    computed: {
        isAuditorRole() {
            return localStorage.getItem("userRole") === 'Auditor'
        }
    },

    watch: {},

    created() {
        this.createSummary = this.$route.query.createSummary === 'true';
        this.updateSummary = this.$route.query.updateSummary === 'true';
        this.getUsers();
        this.getProviders();
    },

    mounted() {
        if (this.updateSummary) {
            this.getWeeklySummary();
        }
    },

    methods: {
        initialize() {
            this.weeklySummaries = [];
        },

        viewWeeklySummary(item) {
            this.titleForm = "Viewing Weekly Summary";
            this.dialog = true;
            this.editSummary = true;
            this.newSummaryBool = false;
            this.newReportDate = item.ReportDate;
            // this.newEndDate = item.EndDate;
            this.newPlanDate = item.PlanDate;
            this.newSummary = item.Summary;
            this.newManagerSignature = item.ManagerSignature;
            this.newSupervisorSignature = item.SupervisorSignature;
            this.newClientServSig = item.ClientServSig;
            this.newSubmitted = item.Submitted;
            this.newProviders = item.Providers;
            this.newGuardian = item.Guardian;
            this.signedManager = !!item.ManagerSignature;
            this.signedSupervisor = !!item.SupervisorSignature;
            this.signedClient = !!item.ClientServSig;
        },

        close() {
            this.$router.go(-1);
            this.clear()
            document.getElementById('printItem').style.display = "none";
        },

        async updateWeeklySummary() {
            let req_body = {
                ReportDate: this.newReportDate,
                // EndDate: this.newEndDate,
                PlanDate: this.newPlanDate,
                Summary: this.newSummary,
                MangerSignature: this.newManagerSignature,
                SupervisorSignature: this.newSupervisorSignature,
                ClientServSig: this.newClientServSig,
                Submitted: this.newSubmitted,
                Providers: this.newProviders,
                Guardian: this.newGuardian,
            };

            try {
                const response = await axios.put(`${url}/weeklySummary/${this.summaryId}`, req_body)

                if (response.status !== 200) {
                    displayError("Failed to update weekly summary");
                }

                displaySuccess("Weekly summary updated successfully");
                this.getWeeklySummaries();
            } catch (error) {
                displayError("Failed to update weekly summary");
            } finally {
                this.close();
            }
        },

        getWeeklySummaries() {
            this.isLoading = true;
            axios.get(`${url}/weeklySummary/client/${this.clientID}`).then(res => {
                this.weeklySummaries = res.data.summaries
            }).finally(() => this.isLoading = false);
        },

        getWeeklySummary() {
            this.isLoading = true;
            axios.get(`${url}/weeklySummary/${this.summaryId}`).then(res => {
                this.weeklySummary = res.data.summary
                this.viewWeeklySummary(this.weeklySummary);
            }).finally(() => this.isLoading = false);
        },

        async addWeeklySummary() {
            let req_body = {
                ReportDate: this.newReportDate,
                PlanDate: this.newPlanDate,
                Summary: this.newSummary,
                ManagerSignature: this.newManagerSignature,
                SupervisorSignature: this.newSupervisorSignature,
                ClientServSig: this.newClientServSig,
                Submitted: this.newSubmitted,
                Providers: this.newProviders,
                Guardian: this.newGuardian,
                ClientID: this.clientID,
            };

            try {
                const response = await axios.post(`${url}/weeklySummary`, req_body)

                if (response.status !== 200) {
                    displayError("Failed to add weekly summary");
                }

                displaySuccess("Weekly summary added successfully");
                this.getWeeklySummaries();
            } catch (error) {
                displayError("Failed to add weekly summary");
            } finally {
                this.close();
            }
        },

        getUsers() {
            axios.get(`${url}/users`).then(async res => {
                this.users = res.data.users;
                for (var i = 0; i < this.users.length; i++) {
                    if (this.userID === this.users[i]._id) {
                        this.staff = this.users[i].Name
                    }
                }
            });
        },

        addManagerSig() {
            if (!this.signedManager) return this.newManagerSignature = ''
            this.newManagerSignature = this.staff + " - " + new Date();
        },

        addSupervisorSig() {
            if (!this.signedSupervisor) return this.newSupervisorSignature = ''
            this.newSupervisorSignature = this.staff + " - " + new Date();
        },

        addClientSig() {
            if (!this.signedClient) return this.newClientServSig = ''
            this.newClientServSig = this.staff + " - " + new Date();
        },

        clear() {
            this.newReportDate = "";
            this.newEndDate = "";
            this.newPlanDate = "";
            this.newSummary = "";
            this.newManagerSignature = "";
            this.newSupervisorSignature = "";
            this.newClientServSig = "";
            this.newSubmitted = "";
            this.newProviders = "";
            this.newGuardian = "";
            this.signedManager = false
            this.signedSupervisor = false
            this.signedClient = false
        },

        getProviders() {
            this.isLoading = true;
            axios.get(`${url}/providers`).then(res => {
                this.providers = [],
                    this.tempData = res.data.providers;
                for (var i = 0; i < this.tempData.length; i++) {
                    if (this.tempData[i].ClientID === this.clientID) {
                        this.providers.push(this.tempData[i])
                    }
                }
            }).finally(() => this.isLoading = false);
        },

        printItem() {
            document.getElementById('printItem').style.display = "block";
            window.print()
            document.getElementById('printItem').style.display = "none";
        },
    },

};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}

#printTable {
    display: none;
}

#printItem {
    display: none;
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}

@media print {
    #printTable {
        display: block;
        border: none;
        width: 1200px;
        padding-right: 300px;
        margin-left: -200px;

    }

    #printItem {
        display: block;
        border: none;
        width: 1200px;
        padding-right: 300px;
        margin-left: -200px;


    }

    .hideOnPrint {
        display: none;
        border: none;
    }

    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
        display: none;
        border: none;

    }

    @page {
        margin: 0;
    }

    body {
        margin: 1.6cm;
    }


}
</style>
